
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"8","fill":"#0E3DE2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20 11l-.814-.581L20 11zm0-1.72l-.814 1.139-.005.007-.014.02-.052.073-.194.278a73.935 73.935 0 00-2.78 4.317c-.761 1.28-1.533 2.687-2.118 4.006C13.455 20.4 13 21.732 13 22.813a1 1 0 102 0c0-.628.295-1.628.851-2.882.54-1.217 1.268-2.55 2.008-3.796a71.97 71.97 0 012.034-3.214l.107-.158a76.54 76.54 0 011.218 1.87 1 1 0 001.692-1.068 78.514 78.514 0 00-2.052-3.083l-.032-.046-.013-.017L20 9.28zm6.19 10.338a1 1 0 10-1.848.764c.438 1.058.658 1.89.658 2.43C25 25.708 22.732 28 20 28c-.961 0-1.858-.28-2.62-.768a1 1 0 10-1.078 1.684A6.839 6.839 0 0020 30c3.895 0 7-3.247 7-7.187 0-.953-.353-2.09-.81-3.195zM10.957 28.04a1 1 0 101.414 1.415l17-17a1 1 0 00-1.414-1.415l-17 17z","fill":"#fff"}})])
          )
        }
      }
    